import { ContentActionTypes, SingleContentTypeActions, SearchActionTypes } from '../actions/ActionTypes';
import { ContentDefinitions } from '../models/contentDefinitions';
import { ContentType } from '../models/ContentType';
import { SearchResultItem } from '../models/SearchResultTypes';
import { initialState, SingleContentTypeState } from '../state/SingleContentTypeState';

export const singleContentTypeReducer = (
  previousState: SingleContentTypeState = initialState,
  action: SingleContentTypeActions
): SingleContentTypeState => {
  switch (action.type) {
    case SearchActionTypes.CHANGE_CONTENT_TYPE:
      return {
        ...previousState,
        searchResults: undefined,
      };
    case SearchActionTypes.CHANGE_CONTENT_BY_URL_PATH:
      // eslint-disable-next-line no-case-declarations
      let contentTypeFilterValue: ContentType;
      for (const currentContentType in ContentDefinitions) {
        if (action.urlPath === ContentDefinitions[currentContentType as ContentType].getPath(action.urls)) {
          contentTypeFilterValue = currentContentType as ContentType;
          return {
            ...previousState,
            contentType: contentTypeFilterValue,
            searchResults: undefined,
          };
        }
      }
      return previousState;
    case SearchActionTypes.CONTENT_FAVORITE_ADDED_ACTION:
      // eslint-disable-next-line no-case-declarations
      const addedFavoriteState = {
        ...previousState,
      };
      if (previousState.searchResults) {
        previousState.searchResults.list.forEach((item, index) => {
          if (item && action.item.id === item.id) {
            if (addedFavoriteState.searchResults) {
              const list = addedFavoriteState.searchResults.list;
              list[index] = { ...list[index], favorite: true };
            }
          }
        });
      }
      return addedFavoriteState;
    case SearchActionTypes.CONTENT_FAVORITE_REMOVED_ACTION:
      // eslint-disable-next-line no-case-declarations
      const removeFavoriteState = {
        ...previousState,
      };
      if (previousState.searchResults) {
        previousState.searchResults.list.forEach((item, index) => {
          if (item && action.item.id === item.id) {
            if (removeFavoriteState.searchResults) {
              const list = removeFavoriteState.searchResults.list;
              list[index] = { ...list[index], favorite: false };
            }
          }
        });
      }
      return removeFavoriteState;
    case ContentActionTypes.SUCCESS:
      //if a call for a different type returns later we dont want to use it if we have allready changed to a new content type
      if (action.data.type === previousState.contentType) {
        return { ...previousState, searchResults: action.data };
      } else {
        return previousState;
      }
    case ContentActionTypes.SUCCESSWITHMETADATA:
      //if a call for a different type returns later we dont want to use it if we have allready changed to a new content type
      if (action.contentType === previousState.contentType) {
        // eslint-disable-next-line no-case-declarations
        const newState = {
          ...previousState,
        };

        if (previousState.searchResults) {
          const newList = [...previousState.searchResults.list];
          const map: { [id: string]: SearchResultItem } = {};
          action.data.forEach((item) => {
            map[item.id] = item;
          });
          newList.forEach((item, index) => {
            if (item && map[item.id]) {
              newList[index] = map[item.id];
            }
          });
          newState.searchResults = {
            ...previousState.searchResults,
            list: newList,
          };
        }

        return newState;
      } else {
        return previousState;
      }
    default:
      return previousState;
  }
};
